<template>
  <v-row>
    <v-col cols="12" md="4" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          NPS Net Promoter Score
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%; color: white !important;"
                    >
                      Tipo de cliente
                    </th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-center"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Encuestas
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá la cantidad de encuestados
                        <br />que se tiene con cada calificación.
                      </span>
                    </v-tooltip>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_nps" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(index, 1)"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c1'"
                        @click="mostrarInput(index, 1)"
                        style="width: 100%"
                        >{{ item.cant_encuestas | numero }}</span
                      >
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 'f' + index + 'c1'"
                        :ref="'f' + index + 'c1'"
                        v-model="datos_nps[index].cant_encuestas"
                        @keydown.tab.stop.prevent="finEdicionDown(index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(index, 1)
                        "
                        @keyup.esc="escape('f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col align-self="center">
            <v-card>
              <p class="text-center display-1" style="width: 100%;">
                NPS: {{ calculaNps() | porcentaje }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          target="_blank"
          rel="noopener noreferrer"
          aria-current="page"
          >aquí</a
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="8">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline">¿Qué es NPS?</v-card-title>
        <v-card-subtitle class="text-justify">
          NPS, abreviatura de net promoter score, es una métrica que calcula la
          probabilidad de que un cliente recomiende a tu empresa o producto.
          Contá el número de promotores, neutros y detractores que tenés, e
          ingresá esos números en la tabla (es decir, si 12 encuestados te
          calificaron 10 y 30 te calificaron con 9, tendrías 42 promotores). El
          porcentaje de detractores se resta del porcentaje de promotores para
          dar un NPS.
          <br />¿Cómo podemos evaluar el resultado? Una primera mirada
          fundamental es entender que un valor negativo debería generar un
          análisis y evaluación de mejora de la experiencia correspondiente. De
          todas formas, siempre es recomendable la comparación con valores de
          NPS de nuestros competidores, para tener un valor de referencia y
          entender oportunidades de mejora.
        </v-card-subtitle>
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline"
          >¿Cómo se obtienen los datos?</v-card-title
        >
        <v-card-subtitle class="text-justify"
          >Para obtener los datos en bruto, enviá una encuesta a tus clientes
          existentes, pidiéndoles que califiquen la probabilidad de que
          recomienden tu producto o servicio a un amigo o
          colega.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline">¿Cómo se calcula?</v-card-title>
        <v-card-subtitle class="text-justify"
          >NPS = (% de encuestados con valores 9 y 10 sobre el total) - (% de
          encuestados con valores de 0 a 6 sobre el total)</v-card-subtitle
        >
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos_nps: [
        { titulo: 'Promotores (9 & 10)', cant_encuestas: null },
        { titulo: 'Neutros (7 & 8)', cant_encuestas: null },
        { titulo: 'Detractores (0-6)', cant_encuestas: null },
      ],
    };
  },
  filters: {
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(val) {
      return ((val * 100).toFixed(2) + '%').replace('.', ',');
    },
  },

  methods: {
    calculaNps: function() {
      var resultado = 0;
      var total_encuestas = 0;
      for (var i = 0; i < 3; i++) {
        total_encuestas += parseInt(this.datos_nps[i].cant_encuestas);
      }
      resultado =
        this.datos_nps[0].cant_encuestas / total_encuestas -
        this.datos_nps[2].cant_encuestas / total_encuestas;
      if (!isFinite(resultado) || (!resultado && resultado !== 0))
        resultado = 0;
      return resultado;
    },
    mostrarInput(fila, columna) {
      var referencia = `f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionUp(fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(fila, columna) {
      var prox_fila = fila < 2 ? fila + 1 : 2;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.campo {
  width: 100%;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
} /* solución a los títulos de vcard que se cortan las palabras a la mitad */
</style>
